export default {
  title: {
    notes: 'Title of import mdg company dialog',
    message: 'Import Company',
  },
  field: {
    mdgCompanyId: {
      notes: 'Label of MDG Company Id field',
      message: 'MDG Company Id',
    },
    mdgCompanyName: {
      notes: 'Label of MDG Company Name field',
      message: 'MDG Company Name',
    },
    parent: {
      notes: 'Label of parent entity field',
      message: 'Parent destination',
    },
  },
  noCompanyWithId: {
    notes: 'Text when no company with given id is found',
    message: 'No company found',
  },
  delayedCreation: {
    notes: 'Notice that imported companies are visible after some time',
    message:
      'It will take approximately 1 minute for the imported company to appear on the list.',
  },
  validation: {
    companyNotFoundInMdg: {
      notes: 'Validation message if no company found',
      message: 'Enter id of company to import',
    },
    companyAlreadyExists: {
      notes: 'Validation message if the mdg company already exists in SAM',
      message: 'The given MDG Company already exists in SAM',
    },
  },
};
